module.exports = __webpack_public_path__ + "static/media/the-best-teachers.728f4b3c.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/the-best-teachers.jpg
 ** module id = 519
 ** module chunks = 0
 **/